/* eslint-disable @typescript-eslint/no-explicit-any */
import { path, identity, prop } from 'ramda';

/**
 * @typedef Bounds
 * @property {number} s
 * @property {number} e
 * @property {number} n
 * @property {number} w
 */
export {
  findBoundsOfPoisAndKiosk,
  findBoundsOfPoiAndKiosk,
  findBoundsOfPois,
  findBoundsOfSegments,
  findBoundsOfRoute,
  findBoundsOfCoordinates,
  findBoundsOfWaypoints,
};

function findBoundsOfPoiAndKiosk(poi: any, kiosk: any) {
  const latitudes = [poi.position.latitude, kiosk.lat];
  const longitudes = [poi.position.longitude, kiosk.lng];
  return findBounds(latitudes, longitudes);
}

function findBoundsOfPoisAndKiosk(pois: any[], kiosk: any) {
  const { lat, lng } = kiosk;
  const [latitudes, longitudes] = getPoisCoordinates(pois);
  return findBounds([...latitudes, lat], [...longitudes, lng]);
}

function findBoundsOfPois(pois: any[]) {
  const [latitudes, longitudes] = getPoisCoordinates(pois);
  return findBounds(latitudes, longitudes);
}

function getPoisCoordinates(pois: any[]) {
  const latitudes = pois.map(path(['position', 'latitude'])).filter(identity) as number[];
  const longitudes = pois.map(path(['position', 'longitude'])).filter(identity) as number[];
  return [latitudes, longitudes];
}

function findBoundsOfWaypoints(waypoints: any[]) {
  const latitudes = waypoints.map(path(['position', 'lat'])).filter(identity) as number[];
  const longitudes = waypoints.map(path(['position', 'lng'])).filter(identity) as number[];
  return findBounds(latitudes, longitudes);
}

function findBoundsOfCoordinates(coordinates: any[]) {
  const latitudes = coordinates.map(prop(0)).filter(identity) as number[];
  const longitudes = coordinates.map(prop(1)).filter(identity) as number[];
  return findBounds(latitudes, longitudes);
}

function findBoundsOfSegments(navline: any[]) {
  const coordinates = navline.flatMap(getNavlineCoordinates);
  const latitudes = coordinates.map(prop(1)) as number[];
  const longitudes = coordinates.map(prop(0)) as number[];
  return findBounds(latitudes, longitudes);
}

/**
 * Bounds across every leg (and every floor) of a route.
 * @param segmentsPerLeg - one array of navline segments per route leg
 */
function findBoundsOfRoute(segmentsPerLeg: any[][]) {
  return findBoundsOfSegments(segmentsPerLeg.flat());
}

function getNavlineCoordinates(navlineSegment: any) {
  const coordinates = navlineSegment.coordinates;
  if (coordinates[0].constructor === Array) {
    return coordinates;
  } else {
    return [coordinates];
  }
}

function findBounds(latitudes: number[], longitudes: number[]) {
  const n = Math.max(...latitudes);
  const s = Math.min(...latitudes);
  const e = Math.max(...longitudes);
  const w = Math.min(...longitudes);
  return { n, s, e, w };
}
